import { Directive, HostListener, Input, Output, EventEmitter } from '@angular/core';
import addDays from 'date-fns/add_days';
import addWeeks from 'date-fns/add_weeks';
import addMonths from 'date-fns/add_months';

/**
 * Change the view date to the next view. For example:
 *
 * ```typescript
 * &lt;button
 *  mwlCalendarNextView
 *  [(viewDate)]="viewDate"
 *  [view]="view"&gt;
 *  Next
 * &lt;/button&gt;
 * ```
 */

export class CalendarNextViewDirective {

  /**
   * The current view
   */
   view: string;

  /**
   * The current view date
   */
   viewDate: Date;

  /**
   * Called when the view date is changed
   */
   viewDateChange: EventEmitter<Date> = new EventEmitter();

  /**
   * @hidden
   */
  
  onClick(): void {

    const addFn: any = {
      day: addDays,
      week: addWeeks,
      month: addMonths
    }[this.view];

    this.viewDateChange.emit(addFn(this.viewDate, 1));

  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mwlCalendarNextView]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'view': [{ type: Input },],
'viewDate': [{ type: Input },],
'viewDateChange': [{ type: Output },],
'onClick': [{ type: HostListener, args: ['click', ] },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
